import { useEffect } from "react";
import {
  Box,
  Typography,
  Stack,
  CircularProgress,
  IconButton,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { GetWebsiteData } from "../redux/slices/website";
import Banner from "../components/website/banners";
import TopGames from "../components/website/topgames";
import { Refresh } from "@mui/icons-material";

export default function Website() {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.website.loading);

  useEffect(() => {
    dispatch(GetWebsiteData());
  }, [dispatch]);

  if (loading) {
    return (
      <Box
        p={3}
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <Stack spacing={2} alignItems="center">
          <CircularProgress />
          <Typography color="text.secondary">
            Loading website data...
          </Typography>
        </Stack>
      </Box>
    );
  }

  return (
    <Box p={3}>
      <Typography variant="h5" fontWeight={600} mb={3} color="text.primary">
        Website Management
        <IconButton
          onClick={() => dispatch(GetWebsiteData())}
          className={loading ? "animate-spin cursor-not-allowed" : ""}
          disabled={loading}
          sx={{
            backgroundColor: "#3f51b5",
            ml: 2,
            color: "white",
            "&:hover": {
              backgroundColor: "#303f9f",
            },
            "&:disabled": {
              backgroundColor: "#e0e0e0",
            },
          }}
        >
          <Refresh />
        </IconButton>
      </Typography>

      <Banner />
      <TopGames />
    </Box>
  );
}
